export enum Ownership {
  Split = 'Split',
  'System-Owned' = 'System-Owned',
  'Customer-Owned' = 'Customer-Owned',
  Unknown = 'Unknown'
}
